import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { Line } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';
import { useTranslation } from 'react-i18next';

// Register essential Chart.js components
ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend);

const LineChartComponent = ({ stats, isVertical }) => {
  const { t } = useTranslation();

  const data = useMemo(() => stats ?? [], [stats]);
  // 1. Map data to Chart.js format
  const chartData = {
    labels: data.map((item) => item.xaxis),
    datasets: [
      {
        label: 'Value',
        data: data.map((item) => item.value),
        borderColor: '#82ca9d',
        backgroundColor: '#82ca9d',
        tension: 0.1, // Smoothness of the line (0 is straight like Recharts default)
        fill: false,
        // show data point as circle
        pointStyle: 'circle',
        pointRadius: 4,
        pointBorderWidth: 1,
        hitRadius: 4,
        hoverRadius: 4,
        showLine: true,
      },
    ],
  };

  // 2. Configuration Options
  const options = {
    responsive: true,
    maintainAspectRatio: false,
    layout: {
      padding: {
        top: 20,
        right: 20,
        left: 20,
        bottom: 20,
      },
    },
    // Setting indexAxis to 'y' swaps the axes for a vertical layout
    indexAxis: isVertical ? 'y' : 'x',
    plugins: {
      legend: {
        position: 'bottom',
      },
      // title: {
      //   display: true,
      //   text: basicProps.label,
      //   color: '#333',
      //   font: { size: 18, weight: 'bold' },
      //   padding: { bottom: 20 },
      // },
      datalabels: {
        display: false,
      },
    },
    scales: {
      x: {
        grid: {
          drawOnChartArea: true,
        },
      },
      y: {
        grid: {
          drawOnChartArea: true,
        },
      },
    },
  };

  return !stats ? (
    <div>{t('text_loading_chart_data')}</div>
  ) : data.length === 0 ? (
    <div>No data to show</div>
  ) : (
    <div className='d-flex flex-column justify-content-center align-items-center'>
      <div className='d-flex flex-grow-1 w-100'>
        <Line data={chartData} options={options} />
      </div>
    </div>
  );
};

LineChartComponent.propTypes = {
  widget: PropTypes.object.isRequired,
  stats: PropTypes.array,
  isVertical: PropTypes.bool,
};

export default LineChartComponent;
